import { render, staticRenderFns } from "./ProposalDateItem.vue?vue&type=template&id=6f07801b&scoped=true"
import script from "./ProposalDateItem.vue?vue&type=script&lang=ts"
export * from "./ProposalDateItem.vue?vue&type=script&lang=ts"
import style0 from "./ProposalDateItem.vue?vue&type=style&index=0&id=6f07801b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07801b",
  null
  
)

export default component.exports